import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseNearMeFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1964 4.77856C20.3078 4.5 20.2425 4.18184 20.0304 3.96969C19.8182 3.75754 19.5 3.69224 19.2215 3.80366L1.72148 10.8037C1.40916 10.9286 1.21822 11.2462 1.25437 11.5806C1.29052 11.9151 1.54492 12.1845 1.87673 12.2398L10.3483 13.6517L11.7602 22.1233C11.8155 22.4551 12.085 22.7095 12.4194 22.7457C12.7539 22.7818 13.0715 22.5909 13.1964 22.2786L20.1964 4.77856Z"
        fill={color}
      />
    </svg>
  );
};
